// Pure helpers for ShadowAgreementPanel.jsx (2026-10-23), so ui/test can run
// them under node --test.

export const CONFIDENCE_ORDER = Object.freeze(['high', 'medium', 'low', 'none'])

export function agreementPct(v) {
  return v == null ? '—' : `${Math.round(v * 100)}%`
}
export function agreementRatio(v) {
  return v == null ? '—' : Number(v).toFixed(2)
}
// "reasonCode (4), reply (3)"
export function changedFieldsLine(list) {
  if (!Array.isArray(list) || !list.length) return '—'
  return list.map((f) => `${f.field} (${f.count})`).join(', ')
}
